<h1 class="mt-2">{{ formTitle }} Post</h1>
<hr />
<mat-card class="mat-elevation-z2 mt-3">
  <form
    #myForm="ngForm"
    (ngSubmit)="myForm.form.valid && saveBlogPost()"
    accept-charset="UTF-8"
    novalidate
  >
    <input
      type="text"
      class="blogHeader"
      placeholder="Add title..."
      class="form-control"
      name="postTitle"
      [(ngModel)]="postData.title"
      #postTitle="ngModel"
      required
    />
    <span
      class="text-danger"
      *ngIf="myForm.submitted && postTitle.errors?.required"
    >
      Title is required
    </span>
    <br />
    <input
      type="text"
      class="blogHeader"
      placeholder="Add Image Url..."
      class="form-control"
      name="imageUrl"
      [(ngModel)]="postData.imageUrl"
      #postTitle="ngModel"
    />
    <br />
    <mat-form-field appearance="fill">
      <mat-label>Quiz</mat-label>
      <select matNativeControl [(ngModel)]="postData.quiz" required name="quiz">
        <option value="amazon">Amazon</option>
        <option value="flipkart">Flipkart</option>
      </select>
    </mat-form-field>
    <!-- <span
    class="text-danger"
    *ngIf="myForm.submitted && postTitle.errors?.required"
  >
    Image URl is required
  </span> -->
    <br />

    <input
      type="text"
      class="blogHeader"
      placeholder="Add Video Id..."
      class="form-control"
      name="videoId"
      [(ngModel)]="postData.videoId"
      #postTitle="ngModel"
    />
    <br />

    <div style="text-align: center">
      <app-video style="margin: auto" [videoId]="postData?.videoId"></app-video>
    </div>

    <div class="form-group">
      <ckeditor
        name="myckeditor"
        [config]="ckeConfig"
        [(ngModel)]="postData.content"
        #myckeditor="ngModel"
        debounce="300"
        [editor]="Editor"
      ></ckeditor>
    </div>

    <mat-card-actions>
      <div fxflex></div>
      <button type="submit" mat-raised-button color="primary">Save</button>
      <button mat-raised-button color="warn" (click)="cancel()">CANCEL</button>
    </mat-card-actions>
  </form>
</mat-card>
